function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M264 113.3V63.2H107V34.7H0V256h238.8l44.6-142.5H264zM28.5 63.2h50v28.5h157v21.6h-196l-10.9 34.9v-85zm189.4 164.1H33.7l26.7-85.5h184.2l-26.7 85.5z",
  id: "My_cases"
})));